import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "chapter-page-editor-container"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_w_tiny_mce = _resolveComponent("w-tiny-mce");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_w_tiny_mce, {
    editorId: _ctx.editorId,
    customConfig: _ctx.editorConfig,
    text: _ctx.editorContent,
    "display-editor-buttons": false,
    onBlur: _ctx.handleEditorBlurEvent
  }, null, 8, ["editorId", "customConfig", "text", "onBlur"])]);
}